import { render, staticRenderFns } from "./ToDoItemCard.vue?vue&type=template&id=05671cce&scoped=true"
import script from "./ToDoItemCard.vue?vue&type=script&lang=js"
export * from "./ToDoItemCard.vue?vue&type=script&lang=js"
import style0 from "./ToDoItemCard.vue?vue&type=style&index=0&id=05671cce&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "05671cce",
  null
  
)

export default component.exports